unit UWebHtml2Pdf;

interface

uses
  WebLib.ExtCtrls;

type
  TGetDataEvent = procedure(Sender: TObject; ABase64: string) of object;

  THtml2Pdf = class
  private
    FHtmlDiv: string;
    FOnGetData: TGetDataEvent;
    procedure DoGetData(ABase64: string);
    procedure Execute(mode: string);
    procedure SetHtmlDiv(const Value: string);
    procedure SetOnGetData(const Value: TGetDataEvent);
  public
    procedure CreateJpg;
    procedure CreatePdf;
    procedure Load(APath: string; AFilename: string);
    procedure Save(APath: string; AFilename: string);
    property HtmlDiv: string read FHtmlDiv write SetHtmlDiv;
    property OnGetData: TGetDataEvent read FOnGetData write SetOnGetData;
  end;

implementation

uses
  WebLib.LocalFiles, System.SysUtils;

{ TWebHtml2Pdf }

procedure THtml2Pdf.CreateJpg;
begin
  Self.Execute('jpg');
end;

procedure THtml2Pdf.CreatePdf;
begin
  Self.Execute('pdf');
end;

procedure THtml2Pdf.DoGetData(ABase64: string);
begin
  if Assigned(Self.OnGetData) then
    Self.OnGetData(Self, ABase64);
end;

procedure THtml2Pdf.Execute(mode: string);
  procedure Response(Value: string);
  begin
    DoGetData(Value);
  end;

begin
  asm
    function scriptLoaded() {
      var element = document.getElementById('maindiv');
      var opt = {image: { type: 'jpeg', quality: 1.0 },
                 pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }};
      if (mode === 'pdf') {
        html2pdf()
          .set(opt)
          .from(element)
          .toPdf()
          .outputPdf('datauristring')
          .then(
            function (datauri) {
              Response(datauri);
            });
      }
      else {
        html2pdf()
          .set(opt)
          .from(element)
          .toImg()
          .outputImg('datauristring')
          .then(
            function (datauri) {
              Response(datauri);
            });
      };
    };
    function pdfCreate(url) {
      var meta = document.getElementById('viewportId');
      if (meta === null) {
        meta = document.createElement('meta');
        meta.id = 'viewportId';
        meta.name = 'viewport',
        meta.content = 'width=device-width, initial-scale=1.0';
        document.head.appendChild(meta);
      };
      var div = document.getElementById('maindiv');
      if (div !== null) {
        div.style = 'margin:12mm';
        var script = document.createElement('script');
        script.addEventListener('load', scriptLoaded);
        script.type = 'application/javascript';
        script.src = url;
        document.body.appendChild(script);
      };
    };
    pdfCreate('html2pdf.bundle.js');
  end;
end;

procedure THtml2Pdf.Load(APath, AFilename: string);
var tFile: TTextFile;
  procedure HandleFileOpen(Sender: TObject);
  begin
    if Sender is TTextFile then
      Self.DoGetData((Sender as TTextFile).Text);
  end;

begin
  tFile := TTextFile.Create(nil);
  tFile.OnFileOpen := HandleFileOpen;
  tFile.OpenFile(APath, AFilename);
end;

procedure THtml2Pdf.Save(APath, AFilename: string);
var
  dummy: TGetDataEvent;
  procedure HandleGetData(Sender: TObject; ABase64: string);
  var
    tFile: TTextFile;
  begin
    tFile := TTextFile.Create(nil);
    tFile.Text := ABase64;
    tFile.SaveAsFile(APath, AFilename);
    Self.OnGetData := dummy;
  end;
begin
  dummy:=Self.OnGetData;
  Self.OnGetData := HandleGetData;
  if AFilename.EndsWith('.pdf', true) then
    Self.CreatePdf;
  if AFilename.EndsWith('.jpg', true) or AFilename.EndsWith('.jpeg', true) then
    Self.CreateJpg;
end;


procedure THtml2Pdf.SetHtmlDiv(const Value: string);
begin
  FHtmlDiv := Value;
end;

procedure THtml2Pdf.SetOnGetData(const Value: TGetDataEvent);
begin
  FOnGetData := Value;
end;

end.
